import { textingColumnTableFilterFn } from '../../../utils/texting';
import { ADA_PATH_MAP } from '../../../utils/ada-helpers';
import { leadSourceFilterFn } from './ApplicationsTable_V2.utils';

export const UNIT_ASSIGNED_OPTIONS = [
  { value: 'yes', text: 'Yes' },
  { value: 'no', text: 'No' },
];

export const PROPERTY_PATH_MAP = (locale) => ({
  applicationCode: {
    path: 'applicationCode',
    dataType: 'number',
  },
  applicants: {
    path: 'applicants',
    dataType: 'string',
  },
  texting: {
    path: 'texting.TOTAL',
    dataType: 'number',
    filterPath: 'texting',
    filterFn: textingColumnTableFilterFn,
  },
  applicationStatusId: {
    path: 'applicationStatus.id',
    dataType: 'string',
  },
  applicantConversionDate: {
    path: 'createdAt',
    dataType: 'date',
  },
  assignedTo: {
    path: 'assigneeName',
    dataType: 'string',
  },
  complianceApprovalHUD: {
    path: 'complianceApprovalHUD',
    dataType: 'string',
  },
  complianceDocumentHUD: {
    path: 'complianceDocumentHUDDate',
    dataType: 'date',
  },
  complianceApproval: {
    path: 'complianceApproval',
    dataType: 'string',
  },
  complianceDocument: {
    path: 'complianceDocumentDate',
    dataType: 'date',
  },
  desiredMoveInDate: {
    path: 'desiredMoveInStartDate',
    dataType: 'date',
  },
  email: {
    path: 'emailAddress',
    dataType: 'string',
  },
  lastActivity: {
    path: 'prospect.lastAct.startTime',
    dataType: 'date',
  },
  nextActivity: {
    path: 'prospect.nextAct.startTime',
    dataType: 'date',
  },
  notes: {
    path: 'notes',
    dataType: 'string',
  },
  phoneNumber: {
    path: 'phoneNumber',
    dataType: 'string',
  },
  scheduledMoveInDate: {
    path: 'moveInDate',
    dataType: 'date',
  },
  unitNumber: {
    path: 'unitNumber',
    dataType: 'string',
    filterPath: 'unitNumber',
    filterFn: (filterBy: string, filterValue: string) => {
      if (filterBy === 'yes') return Boolean(filterValue?.length);
      if (filterBy === 'no') return Boolean(!filterValue);
    },
  },
  buildingNumber: {
    path: 'buildingNumber',
    dataType: 'string',
  },
  ...ADA_PATH_MAP,
  bedsBaths: {
    path: 'bedsBaths',
    dataType: 'string',
  },
  waitlistStartTime: {
    path: 'wlStartTime',
    dataType: 'date',
  },
  waitlistNotes: {
    path: 'waitlistNotes',
    dataType: 'string',
  },
  leadSources: {
    path: 'leadSources',
    dataType: 'string',
    filterPath: 'leadSources',
    filterFn: leadSourceFilterFn,
  },
});
